angular.module('homebot')
  .controller('HomebotCtrl',
    ['$scope', '$rootScope', '$stateParams', '$filter', '$location', '$timeout', '$cookies', '$window', 'AccessService', 'NotificationService', 'DataService', 'Dictionary', 'HelperService', 'ChartService', 'UtilService', 'PageNotificationService', '$sce', 'APP_CONFIG', 'SessionService', 'SSOService',
    function($scope, $rootScope, $stateParams, $filter, $location, $timeout, $cookies, $window, AccessService, NotificationService, DataService, Dictionary, helpers, ChartService, utils, PageNotificationService, $sce, APP_CONFIG, SessionService, SSOService, undefined) {

    var homeId = $stateParams.homeId;
    var dictionary = new Dictionary();
    var saveTimeout;
    var hasBeenTracked = false;
    var isInitialLoad = true;

    $scope.homeUpdateStep = 0;
    $scope.homeLoadError = false;

    $scope.digestRequestLoading = false;
    $scope.sentDigestRequest = false;
    $scope.digestEmail = { value: '' };
    $scope.showAvmGraph = true;


    $scope.init = function(renew){
      AccessService.checkAndSetLocalToken();

      $scope.getHome();
      $scope.getAvmHistory();
    };

    $scope.getHome = function(){
      DataService.getHome({}, homeId)
        .then(function(home){
          $scope.setCachedValues(home);
          $scope.homeLoaded = true;
          $scope.activeView = 'main';
          $scope.agent = home.agent[0];

          if($scope.home && isInitialLoad){
            $scope.doPageloadActions();
            isInitialLoad = false;
          }

        }).catch(function(err){
          $scope.homeLoadError = true;

          if(err && err.status === 401){
            $scope.homeLoadErrorType = 'access';
            utils.track('HomeAccessDenied');
          } else {
            $scope.homeLoadErrorType = 'failure';
            utils.track('HomeLoadFailed');
          }

          utils.trackException('Get Home', helpers.parseAPIError(err));
        });
    };

    $scope.getAvmHistory = function(){
      return DataService.avmHistory(homeId)
        .then((history) => {
          $scope.showAvmGraph = history.valuationCount > 3;
          $scope.avmHistory = history;
        });
    }

    $scope.requestEmail = function () {
      if ($scope.sentDigestRequest) {
        return
      }

      $scope.digestRequestLoading = true;
      DataService.getHomeEmail({ email: $scope.digestEmail.value }, homeId)
        .then(function () {
            $scope.sentDigestRequest = true;
            $scope.digestRequestLoading = false;
        })
    }

    function getSourceAndEvent(){
      var from = $location.search().f;
      if(from === 't')
        return {source:'twilio', event:'view'};
      else if(from === 'email')
        return {source:'mandrill', event:'view'};
      else
        return {source: 'user', event: 'view' };
    };

    $scope.setCachedValues = function(home){
      $scope.isUpdating = true;
      $scope.home = home;

      $scope.home.answers = $scope.home.answers || {};

      $scope.home.currentLoans = helpers.sortByLoanType($scope.lookup('currentLoans'));
      $scope.home.currentLoansNoHelocs = helpers.sortByLoanType($scope.lookup('currentLoansNoHelocs'));

      $scope.home.expiredLoans = helpers.sortByDate($scope.lookup('expiredLoans'), 'date');

      $scope.showAvmDiffWarning = dictionary.showAvmDiffWarning($scope.home);

      $scope.showNonDisclosureStateWarning = dictionary.showNonDisclosureStateWarning($scope.home);

      $scope.showRefiSection = !dictionary.hasRecentLoan({loans: $scope.home.currentLoansNoHelocs});

      $scope.showCashoutRefi = dictionary.showCashoutRefi($scope.home);

      $scope.showBuyingPowerSection = dictionary.showBuyingPowerSection($scope.home);

      $scope.showPmiSection = function () {
        return dictionary.showPmiSection($scope.home);
      }

      $scope.showReverseMortgageSection = dictionary.showReverseMortgageSection($scope.home);

      $scope.cmaDone = dictionary.cmaDone($scope.home);

      $scope.cmaSourceAgent = dictionary.cmaSourceAgent($scope.home);

      $scope.showAvmGraph = dictionary.avmWithoutCMA($scope.home);

      $scope.showAgentPreviewDigestBar = SessionService.isAgent() && Helpers.isFalsey($stateParams.embedded);

      $scope.user = $scope.getCurrentUser();

      $scope.address = $scope.home.address;
      $scope.homeLoaded = true;

      if(SessionService.isAgent())
        $scope.initVideoRecorder();

      _.defer(function(){ $scope.isUpdating = false; });
    };

    $scope.getNotifications = function(){
      return NotificationService.getNotifications($scope.user, $scope.home.id)
        .then((results) => {
          $scope.notifications = results;
          $scope.dataCount = _.filter(results, function(result){
            return !result.is_seen
          }).length;
        }).catch((error) => { return error});
    };

    $scope.listenForNewNotifications = function(){
      var userHomeTokens = _.where($scope.user.notification_tokens, { 'home_ref': homeId })
      if (userHomeTokens.length > 0) {
        var client = window.stream.connect(APP_CONFIG.GETSTREAM_API_KEY, null, APP_CONFIG.GETSTREAM_API_APP);
        var userFeed = client.feed('user_home', `${$scope.user.id}_${homeId}`, userHomeTokens[0].token_value);
        userFeed.subscribe(notificationCallback);
      }
    };

    function notificationCallback(data) {
      $timeout(function(){
        _.each(data.new, function(notification){
          let newNotification = {
            activities: [notification],
            is_seen: false,
            verb: notification.verb
          };
          $scope.notifications.unshift(newNotification);
          $scope.dataCount += 1
        });
      });
    };

    // These depend on user and home information being set in scope
    $scope.doPageloadActions = function(){
      recordPageView();

      if($location.search().unsubscribe)
        $scope.unsubscribe();

      $scope.getNotifications();
      $scope.listenForNewNotifications();
    };

    function recordPageView(){
      if(SessionService.isAgent()) return;

      var user = $scope.getCurrentUser();

      //track event
      var trackEvent = _.merge({homeId:homeId,userId:user.id,agentId:$scope.home.agentId}, getSourceAndEvent());

      DataService.trackHome(trackEvent).then(function(){
        $location.search('f', null);
      });
    };


    $scope.getDisclaimer = function(){
      return $sce.trustAsHtml($scope.home.agent[0].office.brokerage.disclaimer_html);
    }


    $scope.getCurrentUser = function(){
      var currentUser;

      //TODO: This should be reworked in api to send out token links
      // Currently we have first three chars of first_name in ?u url param
      if($location.search().u){
        currentUser = _.filter($scope.home.users, function(user){
          var urlFirstThree = $location.search().u.toLowerCase();
          var userFirst = user.first_name ? user.first_name.toLowerCase() : '';

          if(userFirst && userFirst.indexOf(urlFirstThree)===0) return true;
        })[0];
      }

      return currentUser || $scope.home.users[0];
    };


    $scope.saveInput = function(args){
      if(!args) return;
      $scope.hasSaved = true;
      $scope.saving = true;
      $scope.saveError = false;

      DataService.saveHome(args, homeId).then(
        function success(home){
          $scope.setInitialValues(home);
          $scope.saving = false;
        }, function error(err){
          $scope.saveError = err;
          //TODO add a retry on save if 401
          utils.trackException('Save Input Error', err);
        }
      );
    };

    $scope.lookup = function(prop,args,home){
      home = home || $scope.home;
      return dictionary[prop](home,args);
    };

    $scope.activeViewIs = function(view){
      return $scope.activeView === view;
    };

    $scope.changeView = function(view){
      $scope.activeView = view;
    };

    // Used for setting view values
    // You can't set anything inside of $scope.home with it
    $scope.set = function(prop, val){
      $scope[prop] = val;
    };

    $scope.increment = function(prop, val){
      $scope[prop] = Math.floor(parseInt($scope[prop],10)) + 1;
    };

    $scope.toggle = function(prop){
      $scope[prop] = !$scope[prop];
    };

    $scope.unsubscribe = function(){
      var user = $scope.getCurrentUser();
      DataService.emailSubscribe.unsubscribe($scope.user.id)
        .then(function(user){
          PageNotificationService.success('You have been unsubscribed.');
          $scope.refresh();
        })
        .catch(function(e){
          PageNotificationService.error('There was an error unsubscribing. Please email support@homebot.ai');
        });
    };

    $scope.showMortgageList = function(){
      $rootScope.subView = 'number-entry';
    };

    $scope.showEditMortgage = function(mortgage){
      $scope.addMortgage = false;
      $scope.currentEditMortgage = _.cloneDeep(mortgage);
      $scope.mortgageModal = true;
    };

    $scope.showAddMortgage = function(){
      $scope.addMortgage = true;
      $scope.currentEditMortgage = false;
      $scope.mortgageModal = true;
    };

    $scope.toggleHomePaidInFull = function(){
      $scope.home.answers.isHomePaidInFull = true;
    };

    $scope.refreshAndCloseMortgageModal = function(){
      $scope.refresh();
      $scope.mortgageModal = false;
    };

    $scope.closeMortgageModal = function(){
      $scope.mortgageModal = false;
    };

    $scope.closeDisclaimerModal = function(){
      $scope.disclaimerModal = false;
    };

    $rootScope.$on('openDisclaimerModal', function() {
      $scope.disclaimerModal = true;
    });

    $scope.closeCmaSection = function(){
      $scope.cmaSectionOpen = false;
    };

    $scope.confirmLoan = function(loan){
      loan.rate = loan.rate || loan.rateEstimated;
      loan.termYears = loan.termYears || loan.termYearsEstimated;

      DataService.confirmLoan(loan, loan.id)
        .then(() => {
          $scope.refresh();
        });
    };

    $scope.refresh = function(){
      $scope.getHome();
    };

    $scope.showCmaSection = function(){
      $scope.cmaSectionOpen = true;
    };

    $scope.showBombBombHelpModal = function(){
      if(!$window.localStorage.getItem('hasSeenBombBombHelpModal')) {
        $window.localStorage.setItem('hasSeenBombBombHelpModal', true);
        $scope.bombBombHelpModal = true;
      } else {
        $scope.bombBombHelpModal = false;
      }
    };

    $scope.closeBombBombHelpModal = function(){
      $scope.bombBombHelpModal = false;
    };

    $scope.closeAvmDiffWarningModal = function(){
      $scope.avmDiffWarningModal = false;
    };

    $scope.closeNonDisclosureStateModal = function(){
      $scope.nonDisclosureStateModal = false;
    };

    $scope.initVideoRecorder = function(){
      SSOService.lockboxWhoami('providers')
        .then(user => {
          if(!user || !user.data || !user.data.included) return false;
          try {
            if(user.data.included.length > 0) {
              var bbProvider = user.data.included.find(el => el.attributes.name == "bomb_bomb");
              $scope.videoRecorderApiKey = bbProvider.attributes["api-key"];
              $scope.showBombBombHelpModal();
            }
          } catch(e) { return false; }
        })
        .catch(() => false);
    }

    $scope.date = moment().format('MMMM Do, YYYY');

    $scope.init();
  }]);
